/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Hero_EyebrowInputs */

const es_exp_mk_hero_eyebrow = /** @type {(inputs: Exp_Mk_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navega acompañado`)
};

const gl_exp_mk_hero_eyebrow = /** @type {(inputs: Exp_Mk_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navega acompañado`)
};

const en_exp_mk_hero_eyebrow = /** @type {(inputs: Exp_Mk_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sail together`)
};

/**
* | output |
* | --- |
* | "Sail together" |
*
* @param {Exp_Mk_Hero_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_hero_eyebrow = /** @type {((inputs?: Exp_Mk_Hero_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Hero_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_hero_eyebrow(inputs)
	if (locale === "en") return en_exp_mk_hero_eyebrow(inputs)
	return es_exp_mk_hero_eyebrow(inputs)
});